// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const SMSSignatureService = {
    /**
     * Upsert inserts or updates a "signature" for SMS Weave user for a location or business group
     * and echos back the signature in the response.
     * Upserting an empty signature effectively deletes it for that user. In other words,
     * getting an empty signature or a non-existent signature provide the same response.
     */
    Upsert(fn, req) {
        return fn(`/sms/signature/v1/signature`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Get returns the signature for the given location_id/group_id and user_id. A valid
     * location/user combination will always at least return an empty signature if no
     * signature is defined.
     */
    Get(fn, req) {
        return fn(`/sms/signature/v1/signature?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
